import { render, staticRenderFns } from "./TypedForm.vue?vue&type=template&id=4077eafe&"
import script from "./TypedForm.vue?vue&type=script&lang=js&"
export * from "./TypedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports